import Experience from '../Experience.js'

export default class TeeSelection {
    constructor() {
        this.experience = new Experience()
        this.root = document.querySelector('.tee-selection')
        this.options = this.root?.querySelectorAll('[data-tee]') ?? []
        this.selectedColor = null

        this.setCourseLengths()
        this.bindEvents()
    }

    // Longueur totale du parcours pour chaque départ
    setCourseLengths() {
        const holes = Object.values(this.experience.resources.items.info ?? {})

        for (const button of this.options) {
            const total = holes.reduce((sum, hole) => sum + (Number(hole[button.dataset.tee]) || 0), 0)
            const length = button.querySelector('[data-length]')
            if (length && total) length.textContent = `${total.toLocaleString('fr-FR')} m`
        }
    }

    bindEvents() {
        for (const button of this.options) {
            button.addEventListener('click', () => {
                this.select(button.dataset.tee)
            })
        }
    }

    select(color) {
        if (!color || this.selectedColor) return

        this.selectedColor = color
        document.body.classList.remove('tee-selection-pending')

        for (const button of this.options) {
            button.disabled = true
            button.classList.toggle('is-selected', button.dataset.tee === color)
        }

        this.root?.classList.add('is-hidden')
        this.root?.setAttribute('aria-hidden', 'true')

        this.experience.ballTrajectory?.setTeeColor(color)
        this.experience.timeline?.setTeeColor(color)
        this.experience.timeline?.resume()
    }

    show() {
        document.body.classList.add('tee-selection-pending')
        this.root?.classList.remove('is-hidden')
        this.root?.setAttribute('aria-hidden', 'false')
    }

    reset() {
        this.selectedColor = null
        this.experience.ballTrajectory?.resetTeeColor?.()
        this.experience.timeline?.setTeeColor(null)

        for (const button of this.options) {
            button.disabled = false
            button.classList.remove('is-selected')
        }

        document.body.classList.remove('tee-selection-pending')
        this.root?.classList.add('is-hidden')
        this.root?.setAttribute('aria-hidden', 'true')
    }

    destroy() {
        for (const button of this.options) {
            button.replaceWith(button.cloneNode(true))
        }
        this.root = null
        this.options = []
    }
}
